import { connectAndUpdateStateForMultiNetworks } from '../common/mod.js';

export const recommended = [
  ['connect', connectAndUpdateStateForMultiNetworks] as const,
];
